import { Table } from "@/features/Table";
import { useTranslation } from "react-i18next";
import { S3EventRow, useS3EventColumns } from "./columns";
import { FilterS3Events, type FilterS3EventsSchema } from "./filter";

const client = "s3";
const table_name = "s3_events";

export function S3EventsTable() {
  const { t } = useTranslation();
  const columns = useS3EventColumns();

  return (
    <Table<S3EventRow, FilterS3EventsSchema>
      label={t(`${table_name}.title`, { ns: "tables", defaultValue: "Events" })}
      client={client}
      table_name={table_name}
      columns={columns}
      columnVisibilityInit={{ created_at: false, updated_at: false }}
      filter={<FilterS3Events />}
      actions={[
        {
          label: "actions.new",
          route: `${client}/${table_name}/new`,
        },
      ]}
    />
  );
}
